// extracted by mini-css-extract-plugin
module.exports = {"container":"title_container__1najB","overtitle":"title_overtitle__qkg1I","title":"title_title__LtAn6","subtitle":"title_subtitle__2fJx-"};